export default {
    domains: []
}